import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, useNavigate } from "react-router-dom"; // Import BrowserRouter
import { MsalProvider } from "@azure/msal-react";
//import { msalInstance } from "./msalConfig";
import App from "./App";
import './index.css';
import { PublicClientApplication, EventType } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig";

// Create a root element for React 18
const root = ReactDOM.createRoot(document.getElementById("root"));


export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();
//console.log("MSAL Instance:", msalInstance);

// Wrap App with BrowserRouter and MsalProvider
root.render(
  <React.StrictMode>

  {/*  <MsalProvider instance={msalInstance}> */}
      <BrowserRouter>
        <App pca={msalInstance}/>
      </BrowserRouter>
  {/*  </MsalProvider> */}

  </React.StrictMode>
);
